import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default useStyles;
